import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector:
    "[personalId][formControlName],[personalId][formControl],[personalId][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PersonalIdValidator),
      multi: true,
    },
  ],
})
export class PersonalIdValidator implements Validator {
  constructor(@Attribute("personalId") public personalId: string) {}

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // value not equal
    if (v && !this.isValidIsraeliID(v)) {
      return {
        personalId: false,
      };
    }

    return null;
  }

  public isValidIsraeliID(id: any) {
    // 	var id = String(id).trim();
    if (id.length > 9 || id.length < 5 || isNaN(id)) return false;

    // Pad string with zeros up to 9 digits
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;

    return (
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
      0
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/personalId.validator.ts